<template>
  <section class="section-wrapp">
    <Breadcrumbs
      v-if="breadcrumbsData !== null"
      v-bind:parameters="breadcrumbsData"
    ></Breadcrumbs>

    <section class="section-graph">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="weather-graph-start">
              <highcharts
                :key="componentKey"
                :options="chartOptions"
              ></highcharts>
            </div>
          </div>
          <div class="col-12 col-lg-4 inverters">
            <flat-pickr
              v-model="dataTime"
              :config="config"
              style="display: none;"
              name="date"
            ></flat-pickr>
            <div style="width: 308px; margin-top: 24px;">
              <flat-pickr
                v-model="exportDate"
                :config="{
                  dateFormat: 'Y-m-d',
                  mode: 'range',
                  locale: { rangeSeparator: ' : ', firstDayOfWeek: 1 }
                }"
                name="date"
              ></flat-pickr>
              <div class="export_container">
                <div class="export_select">
                  <select name="mode" id="" v-model="exportMode">
                    <option value="1">All</option>
                    <option value="2">By date</option>
                  </select>
                </div>
                <div class="export_btn_wr">
                  <div
                    class="export_btn statistic-new-download"
                    @click="exportCSV"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      style="margin-top: 16px"
      v-if="currentData !== null"
      class="section-graph"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="inverters_wrap">
              <div
                class="inverters_wrap_item"
                v-for="(values, ktp) in currentData"
              >
                <div class="inverters_title">KTP {{ ktp }}</div>
                <div
                  class="main-stations__inverters_item_square inverters_block"
                >
                  <div
                    v-for="inverter in sortByNumber(values)"
                    :key="inverter.name"
                    :title="
                      inverter.name + ' (' + formatTime(inverter.time) + ')'
                    "
                    class="square-col"
                  >
                    <div
                      @click="() => (selectedData = inverter)"
                      :class="inverterSquareClass(inverter)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div v-if="selectedData !== null" class="inverter_data">
              <div class="inverter_data_title">
                Inverter <span>{{ selectedData.name }}</span>
              </div>
              <div>
                <div
                  v-for="(value, key) in selectedData.data"
                  class="inverter_data_line"
                >
                  <div>{{ key }}</div>
                  <div class="inverter_data_value">{{ round(value) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import DataAPI from "../../api/data.js";
import StationAPI from "../../api/station.js";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import { Chart } from "highcharts-vue";
import graphConfigs from "@/components/graphConfigs";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/themes/dark.css";
import "../../assets/css/js-datapicer.css";
import moment from "moment";
import _get from "lodash/get";
import _forEach from "lodash/forEach";
import _groupBy from "lodash/groupBy";
import _uniq from "lodash/uniq";
import _sortBy from "lodash/sortBy";
import _find from "lodash/find";

// stockInit(Highcharts)

export default {
  name: "InvertersNew",
  mixins: [graphConfigs],
  components: { Breadcrumbs, flatPickr, highcharts: Chart },
  data() {
    return {
      sample: null,
      station: null,
      breadcrumbsData: null,
      title: "",
      exportDate: null,
      exportMode: "1",
      config: {
        dateFormat: "Y-m-d",
        inline: true,
        locale: {
          firstDayOfWeek: 1
        },
        onChange: selectedDates => {
          let dateTime = moment(selectedDates[0]);
          this.fetchData(dateTime);
        },
        disable: [
          date =>
            moment(date).format("YYYY-MM-DD") > moment().format("YYYY-MM-DD")
        ]
      },
      dataTime: moment().format("YYYY-MM-DD"),
      componentKey: 0,
      chartOptions: {
        chart: {
          marginLeft: 60
        },
        title: {
          text: "Inverters daily production",
          style: {
            color: "#ffffff"
          }
        },
        tooltip: {
          formatter: function() {
            return (
              '<span style="color:#f36f37;">' +
              this.point.name +
              "</span>" +
              ": " +
              this.y +
              " kWh"
            );
          }
        },
        yAxis: {
          labels: {
            style: {
              color: "#ffffff"
            }
          },
          gridLineColor: "#595c5e",
          title: {
            style: {
              color: "#ffffff"
            },
            text: "Production, kWh"
          }
        },
        xAxis: {
          labels: {
            style: {
              color: "#ffffff"
            }
          }
        }
      },
      inverters: null,
      invertersMap: null,
      devices: null,
      deviceMap: null,
      currentData: null,
      selectedData: null,
      currentDataInterval: null
    };
  },
  created() {
    let id = this.$route.params.id;

    StationAPI.gridInverters(id).then(r => {
      this.inverters = r.data;
      this.fetchData(moment());
      this.loadCurrentData();
    });

    this.currentDataInterval = setInterval(this.loadCurrentData, 30 * 1000);

    this.$store
      .dispatch("station/findOne", id)
      .then(station => {
        this.station = station;

        this.breadcrumbsData = [
          {
            url: "/station-view/" + station.id,
            title: station.title
          },
          {
            url: "#",
            title: station.title + " (Grid inverters)"
          }
        ];
        this.title = station.title + " (" + station.totalPower + " MW)";
      })
      .catch(e => {
        console.log("Got transfer error: " + e.message);
      });
  },
  beforeDestroy() {
    clearInterval(this.currentDataInterval);
  },
  methods: {
    formatTime(val) {
      return moment.unix(val).format("HH:mm");
    },
    inverterSquareClass(inverter) {
      if (moment.unix() - inverter.time > 6 * 60 * 60) {
        return "square-item yellow";
      }

      return inverter.data["Active_power"] > 0
        ? "square-item green"
        : "square-item grey";
    },
    sortByNumber(inverters) {
      return _sortBy(inverters, "number");
    },
    round(val) {
      return Math.round(Number(val) * 100) / 100;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    exportCSV() {
      let id = this.$route.params.id;

      let match;
      let from;
      let to;

      if (
        (match = this.exportDate.match(
          /(\d{4}-\d{2}-\d{2})\s\:\s(\d{4}-\d{2}-\d{2})/
        ))
      ) {
        from = match[1];
        to = match[2];
      } else if ((match = this.exportDate.match(/(\d{4}-\d{2}-\d{2})/))) {
        from = match[1];
        to = match[1];
      }
      DataAPI.gridInvertersProduction(id, from, to).then(r => {
        let csv = this.getExportData(r.data);

        const anchor = document.createElement("a");
        anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        anchor.target = "_blank";
        anchor.download =
          "inverters_production_" +
          moment().format("YYYY-MM-DD_hh:mm:ss") +
          ".csv";
        anchor.click();
      });
    },
    getExportData(data) {
      data = _sortBy(data, ["time", "inverter_id"]);

      if (this.exportMode == "2") {
        return this.exportGroupedData(data);
      } else {
        return this.exportAllData(data);
      }
    },
    exportAllData(data) {
      let csv = "Date;Device;Production;Device #\n";

      let deviceMap = new Map();

      this.inverters.forEach(inv => {
        deviceMap.set(inv.id, inv);
      });

      data = data.map(line => {
        let time = moment(line.time, "YYYY-MM-DD hh:mm:ss").format(
          "YYYY-MM-DD"
        );

        let name = this.getNameById(line.inverter_id).name;
        let number = this.getNameById(line.inverter_id).number;

        let production = String(line.production).replace(".", ",");

        return { time, name, production, number };
      });

      data = _sortBy(data, ["time", "number"]);

      data.forEach(row => {
        csv += `${row.time};${row.name};${row.production};${row.number}`;
        csv += "\n";
      });

      return csv;
    },
    exportGroupedData(data) {
      let dates = _uniq(data.map(val => val.time));

      let result = _groupBy(data, function(item) {
        return item.inverter_id;
      });

      _forEach(result, function(value, key) {
        result[key] = _groupBy(value, function(item) {
          return item.time;
        });
      });

      let deviceMap = new Map();

      this.inverters.forEach(inv => {
        deviceMap.set(inv.id, inv);
      });

      let rows = [];

      _forEach(result, (value, key) => {
        let inverter_id = Number(key);
        let number;
        let name;
        if (deviceMap.has(inverter_id)) {
          number = deviceMap.get(inverter_id).number;
          name = deviceMap.get(inverter_id).name;
        }

        let row = [number, name];

        _forEach(dates, date => {
          let production = _get(value, `[${date}][0][production]`, null);
          if (production) {
            production = String(production).replace(".", ",");
          }

          row.push(production);
        });

        rows.push(row);
      });

      rows = _sortBy(rows, [r => r[0]]);

      rows.unshift([
        "Device #",
        "Name",
        ...dates.map(d => moment(d, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD"))
      ]);

      let csv = "";

      rows.forEach(row => {
        csv += row.join(";");
        csv += "\n";
      });

      return csv;
    },
    loadCurrentData() {
      let id = this.$route.params.id;

      StationAPI.liveData(id).then(r => {
        let values = r.data.map(val => {
          let inv = this.getNameBySn(val.sn);
          let nameArr = inv.name.split(".");

          let ktp;
          const match = nameArr[0].match(/\d+/); // Finds the first sequence of digits

          if (match) {
            ktp = parseInt(match[0], 10);
          } else {
            ktp = 0;
          }

          return {
            number: inv.number,
            name: inv.name,
            ktp: ktp,
            data: val.data,
            time: val.time
          };
        });

        this.currentData = _groupBy(values, "ktp");
        this.selectedData = null;
      });
    },
    parseData() {
      let dataset = [];

      // Daily_energy
      this.sample.forEach((inverter, idx) => {
        let val = _get(inverter, `[data][Daily_energy]`, null);
        let name = this.getNameBySn(inverter.sn).name;
        let number = this.getNameBySn(inverter.sn).number;

        dataset.push({
          x: number,
          y: Math.round(val * 100) / 100,
          name: name
        });
      });

      this.chartOptions.series = [
        {
          type: "scatter",
          name: "Inverters",
          data: dataset,
          marker: {
            radius: 4
          }
        }
      ];
      this.forceRerender();
    },
    getNameBySn(sn) {
      return _find(this.inverters, { sn: sn });
    },
    getNameById(invId) {
      return _find(this.inverters, { id: invId });
    },
    getNumberFromName(name) {
      let arr = name.split(".");
      return Number(arr[2]);
    },
    fetchData(dateTime) {
      let id = this.$route.params.id;

      if (dateTime.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
        StationAPI.liveData(id).then(r => {
          this.sample = r.data;
          this.parseData();
        });
      } else {
        DataAPI.gridInvertersProduction(
          id,
          dateTime.format("YYYY-MM-DD"),
          dateTime.format("YYYY-MM-DD")
        ).then(r => {
          let dataset = [];

          r.data.forEach(inverter => {
            let val = Number(inverter.production);
            let name = this.getNameById(inverter.inverter_id).name;
            let number = this.getNameById(inverter.inverter_id).number;

            dataset.push({
              x: number,
              y: val,
              name: name
            });
          });

          this.chartOptions.series = [
            {
              type: "scatter",
              name: "Inverters",
              data: dataset,
              marker: {
                radius: 4
              }
            }
          ];
          this.forceRerender();
        });
      }
    }
  }
};
</script>

<style>
.inverters .flatpickr-day {
  color: white;
}

.flatpickr-days .flatpickr-day {
  color: white;
}

.inverters .flatpickr-calendar {
  box-shadow: none;
}

.export_container {
  display: flex;
  float: left;
  width: 100%;
  align-items: end;
}

.export_select {
  flex: 1;
}

.export_btn_wr {
  width: 54px;
  margin-left: 12px;
}

.export_btn_wr .statistic-new-download::before {
  left: 12px;
}

.export_btn {
  background-color: #f36f37;
  width: 100%;
  height: 44px;
  border-radius: 4px;
}

.inv-green {
  background-color: #00a651;
}

.inverters_wrap {
  display: flex;
  /* flex-direction: column; */
  flex-wrap: wrap;
}

.inverters_wrap_item {
  flex: 1 0 21%;
  /* margin: 5px; */
}

.inverters_title {
  color: #fff;
  font-weight: 700;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 8px;
}

.inverters_block {
  margin-top: 8px;
}

.inverter_data {
  color: white;
  width: 308px;
}

.inverter_data_title {
  font-weight: 700;
  padding-top: 8px;
  padding-bottom: 8px;
}

.inverter_data_title span {
  color: #f36f37;
  margin-left: 10px;
  font-size: 16px;
}

.inverter_data_line {
  color: #87898a;
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
}

.inverter_data_line .inverter_data_value {
  color: white;
  font-size: 16px;
}

.square-item.yellow {
  background-color: #eabe43;
}
</style>
